import { Link } from "react-router-dom";

const columns = [
  {
    title: "影视内容",
    links: [
      { label: "热门电影", to: "/category/电影" },
      { label: "热播电视剧", to: "/category/电视剧" },
      { label: "综艺推荐", to: "/category/综艺" },
      { label: "全站搜索", to: "/search" },
    ],
  },
  {
    title: "看片工具",
    links: [
      { label: "APP 推荐榜", to: "/app" },
      { label: "免费看片", to: "/app?category=免费" },
      { label: "电视大屏", to: "/app?category=免费" },
      { label: "关于我们", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-primary-200">
      <div className="w-full max-w-page mx-auto px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500">
                <i className="ri-movie-2-fill text-lg text-primary-950"></i>
              </span>
              <span className="text-lg font-bold text-background-50">看片免费app网站</span>
            </div>
            <p className="text-sm leading-7 text-primary-300 max-w-md">
              一个专注于高清影视资源整理与看片应用推荐的影视门户。我们聚合电影、电视剧、综艺的详细介绍与观看工具，
              帮助你更快找到今晚要看的那一部。
            </p>
            <p className="mt-4 text-xs text-primary-400 leading-6">
              本站影视资料与应用介绍均为内容展示用途，下载与播放功能为前端演示状态，不提供实际片源存储。
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4">{column.title}</h3>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-primary-300 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-400">© 2026 看片免费app网站 · 内容仅供演示与影视资讯参考</p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-primary-400">
            <span>联系我们：hello@kanpian-free.example</span>
            <span className="hidden sm:inline">·</span>
            <Link to="/about" className="hover:text-accent-400 transition-colors">
              反馈与建议
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}